import { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getUserId, isLoggedIn, logout, subscribe } from '../state/auth';

// AdminLayout 给所有登录后页面套侧导 + 顶 bar；未登录时 redirect /login。
// 监听 auth 变化（subscribe）— 任何子页面 401 触发 logout 会自动 redirect。
export default function AdminLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const [, force] = useState(0);

  useEffect(() => subscribe(() => force((n) => n + 1)), []);
  useEffect(() => {
    if (!isLoggedIn()) nav('/login', { replace: true });
  }, [nav, loc.pathname]);

  if (!isLoggedIn()) return null;

  const userId = getUserId() ?? '';
  return (
    <div style={S.wrap}>
      <aside style={S.sidebar}>
        <div style={S.brand}>家理理 Admin</div>
        <nav style={S.nav}>
          <NavLink to="/" label="📊 仪表盘" active={loc.pathname === '/'} />
          <NavLink
            to="/reports"
            label="🚨 举报队列"
            active={loc.pathname.startsWith('/reports')}
          />
          <NavLink
            to="/feedback"
            label="💬 用户反馈"
            active={loc.pathname.startsWith('/feedback')}
          />
          <NavLink
            to="/posts"
            label="📝 帖子审核"
            active={loc.pathname.startsWith('/posts')}
          />
        </nav>
        <div style={S.footer}>
          <div style={S.userId}>{userId}</div>
          <button style={S.logoutBtn} onClick={() => { logout(); nav('/login'); }}>
            退出
          </button>
        </div>
      </aside>
      <main style={S.main}>
        <Outlet />
      </main>
    </div>
  );
}

function NavLink({
  to,
  label,
  active,
}: {
  to: string;
  label: string;
  active: boolean;
}) {
  return (
    <Link
      to={to}
      style={{
        ...S.navItem,
        background: active ? '#1f9d8f' : 'transparent',
        color: active ? 'white' : '#444',
      }}
    >
      {label}
    </Link>
  );
}

const S: Record<string, React.CSSProperties> = {
  wrap: { display: 'flex', minHeight: '100vh', background: '#f5f5f7' },
  sidebar: {
    width: 220,
    background: 'white',
    borderRight: '1px solid #eee',
    display: 'flex',
    flexDirection: 'column',
  },
  brand: {
    padding: 20,
    fontWeight: 700,
    fontSize: 18,
    borderBottom: '1px solid #eee',
  },
  nav: { flex: 1, padding: 12 },
  navItem: {
    display: 'block',
    padding: '10px 14px',
    marginBottom: 4,
    borderRadius: 6,
    textDecoration: 'none',
    fontSize: 14,
  },
  footer: { padding: 16, borderTop: '1px solid #eee' },
  userId: {
    fontSize: 11,
    color: '#999',
    marginBottom: 8,
    wordBreak: 'break-all',
  },
  logoutBtn: {
    width: '100%',
    padding: '6px 12px',
    background: 'white',
    border: '1px solid #d33',
    color: '#d33',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 13,
  },
  main: { flex: 1, padding: 24, overflow: 'auto' },
};
